/*
 * Boot state
 * ==========
 *
 * The first state of the game, responsible for setting up some Phaser
 * features. Adjust the game appearance, number of input pointers, screen
 * orientation handling etc. using this game state.
 */

import assets from '../assets'

export default class Boot extends Phaser.State {

  preload () {

    //  Add a tabindex
    this.game.canvas.tabIndex = 1;
    this.game.canvas.style.outline = 'none';

    this.game.clearBeforeRender = false;

    // Point the Phaser Asset Loader to where your game assets live.
    this.load.path = 'assets/';

    // Adjust how many pointers Phaser will check for input events.
    this.input.maxPointers = 1;

    // Set the alignment of the game canvas within the page.
    this.scale.pageAlignHorizontally = true;

    this.scale.scaleMode = Phaser.ScaleManager.RESIZE;

    // If the game canvas loses focus, keep the game loop running.
    this.stage.disableVisibilityChange = true;

    // Load the graphical assets required to show the splash screen later,
    // using the asset pack data.
    this.load.pack('boot', null, assets)
  }

  create () {
    // After applying the first adjustments and loading the splash screen
    // assets, move to the next game state.
    this.state.start('Preload')
  }

}
